/**
 * Only the keys that have a value, so absent choices are not sent as null
 * (or as `?from=` on a query string). `0` and `false` are values and stay.
 *
 * Shared by the portal's HTTP halves (OperatorPortalApi, DispatcherPortalApi)
 * for both query params and request bodies.
 *
 * @param {object} object
 * @returns {object}
 */
export default function compactParams(object = {}) {
  return Object.fromEntries(
    Object.entries(object).filter(([, value]) => value !== undefined && value !== null && value !== ''),
  );
}
